var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AgencyService } from './../api/agency.service';
import { OnInit, Injector } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { OpenModalService } from './shared/modals/open-modal.service';
import { BaseComponent } from './base-component';
var ServicesBaseComponent = /** @class */ (function (_super) {
    __extends(ServicesBaseComponent, _super);
    function ServicesBaseComponent(injector, agencyService, route, openModalService) {
        var _this = _super.call(this, injector) || this;
        _this.agencyService = agencyService;
        _this.route = route;
        _this.openModalService = openModalService;
        _this.reasons = [];
        return _this;
    }
    ServicesBaseComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.data.forEach(function (data) {
            _this.validateRouteDataParams(data, ['services']);
            _this.services = data.services;
        });
        this.route.data.forEach(function (data) {
            _this.validateRouteDataParams(data, ['reasons']);
            _this.reasons = data.reasons;
        });
        this.setTitle('Servicii ' + this.agencyService.agency.name);
    };
    ServicesBaseComponent.prototype.openServiceModal = function (service) {
        this.openModalService.showDetailsModal(service.name, undefined, service.description, service.image);
    };
    ServicesBaseComponent.prototype.openReasonModal = function (reason) {
        this.openModalService.showDetailsModal(reason.name, undefined, reason.description, reason.image);
    };
    return ServicesBaseComponent;
}(BaseComponent));
export { ServicesBaseComponent };



// WEBPACK FOOTER //
// ./src/app/common-theme/base-components/services-base.component.ts.pre-build-optimizer.js